/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiGroupReservationFromJSON, StreemApiGroupReservationToJSON, StreemApiInvitationFromJSON, StreemApiInvitationToJSON, StreemApiUserFromJSON, StreemApiUserToJSON, } from './';
export function StreemApiAuthIdentityUserFromJSON(json) {
    return StreemApiAuthIdentityUserFromJSONTyped(json, false);
}
export function StreemApiAuthIdentityUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : StreemApiUserFromJSON(json['user']),
        'invitation': !exists(json, 'invitation') ? undefined : StreemApiInvitationFromJSON(json['invitation']),
        'groupReservation': !exists(json, 'group_reservation') ? undefined : StreemApiGroupReservationFromJSON(json['group_reservation']),
    };
}
export function StreemApiAuthIdentityUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': StreemApiUserToJSON(value.user),
        'invitation': StreemApiInvitationToJSON(value.invitation),
        'group_reservation': StreemApiGroupReservationToJSON(value.groupReservation),
    };
}
//# sourceMappingURL=StreemApiAuthIdentityUser.js.map